import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';

import videos from 'app/config/videos.json';
import { VideoDetail, VideoList } from 'app/types';

@Component({
  selector: 'fintech-content',
  standalone: true,
  imports: [
    RouterModule,
  ],
  templateUrl: './content.component.html',
})
export class ContentComponent {
    title = "Kizano's FinTech Content";
    input = videos;
    category = '';
    categories: string[] = videos.videos.map(video => video.category)
      .filter((value, index, self) => self.indexOf(value) === index);
    videos: VideoDetail[] = (<VideoList>videos).videos.filter(v => v.category === this.category) ?? [];

    constructor(protected route: ActivatedRoute) {
        this.route.params.subscribe(params => {
            console.log('ContentComponent().params: ', params);
            this.category = params['category'];
            this.videos = (<VideoList>videos).videos.filter(v => v.category === this.category);
        });
    }

}
